import analyticsBrowser from '../../clients/analytics';
import initializeAnalytics from '../initialize-analytics';
import initializeGuidesAndSurveys from '../initialize-guides-and-surveys';

function setupAnalytics({
  segmentWriteKey,
  amplitudeGuidesAndSurveysApiKey,
  options,
  supplementalContextHelpers,
}) {
  initializeAnalytics(
    analyticsBrowser,
    segmentWriteKey,
    options,
    supplementalContextHelpers
  );
  initializeGuidesAndSurveys(analyticsBrowser, amplitudeGuidesAndSurveysApiKey);
}

export default setupAnalytics;
